import { Params, useParams as useReactParams } from 'react-router-dom';


export function useParams<T extends {}>() {
    return useReactParams() as Readonly<T & Params<string>>;
}
